import { useEffect, useState } from "react";

const _data_theme_key = 'data-theme';

export const _theme_event: string = 'chase-site-data-theme-change';

export function useDataTheme() {

    const getPreferredTheme = (): string => {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    };

    const read = (): string => {
        try {
            const raw = localStorage.getItem(_data_theme_key);
            if (!raw || raw === 'undefined' || raw === 'null' || raw === '') {
                return getPreferredTheme();
            }

            return raw;
        } catch {
            return getPreferredTheme();
        }
    };

    const [value, setValue] = useState<string>(read());

    useEffect(() => {
        try {
            document.documentElement.setAttribute(_data_theme_key, value);
            localStorage.setItem(_data_theme_key, value);
            window.dispatchEvent(new CustomEvent<string>(_theme_event, {detail: value}));
        } catch {}
    }, [value]);

    const refresh = () => setValue(read());

    return [value, setValue, refresh] as const;
}

export default useDataTheme;